/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { heartbeat } from 'features/liveReport/asyncThunks'

const useRetrieveHeartbeat = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(heartbeat())
    }, 20000)

    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [dispatch])
}

export default useRetrieveHeartbeat
